import { cliSimpleGit } from '../cli-simple-git.js';

export async function gitRenameCurrentBranch(repoDir: string, newName: string): Promise<void> {
  const g = cliSimpleGit(repoDir);
  await g.raw(['branch', '-m', newName]);
}
